import {
  Box,
  Center,
  Divider,
  Spinner,
  Stack,
  StackDivider,
} from '@chakra-ui/react';
import * as React from 'react';

import { Loading } from '@/imports/ui/chakra/components/Loading';

import { MemberDirectory_Search_memberDirectorySearch_results } from '../../hooks/graphql-types/MemberDirectory_Search';
import { Member } from './components/Member';

export const Hits: React.FC<{
  members: MemberDirectory_Search_memberDirectorySearch_results[];
  loading: boolean;
  hasMore?: boolean;
  isLoadingMore?: boolean;
  onLoadMore?: () => void;
}> = ({ members, loading, hasMore, isLoadingMore, onLoadMore }) => {
  const sentinelRef = React.useRef<HTMLDivElement | null>(null);
  const isLoadingMoreRef = React.useRef(false);

  React.useEffect(() => {
    const sentinel = sentinelRef.current;

    if (!sentinel || !hasMore || !onLoadMore) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (
          !entry.isIntersecting ||
          isLoadingMoreRef.current ||
          isLoadingMore
        ) {
          return;
        }

        isLoadingMoreRef.current = true;
        onLoadMore();
      },
      {
        rootMargin: '250px',
      }
    );

    observer.observe(sentinel);

    return () => {
      observer.disconnect();
    };
  }, [hasMore, isLoadingMore, onLoadMore]);

  React.useEffect(() => {
    if (!isLoadingMore) {
      isLoadingMoreRef.current = false;
    }
  }, [isLoadingMore, members.length]);

  if (loading && members.length === 0) {
    return <Loading />;
  }

  return (
    <>
      {!!members.length && <Divider my="4" />}
      <Stack spacing="4" divider={<StackDivider />}>
        {members.map((member) => (
          <Member key={member._id} member={member} />
        ))}
      </Stack>

      {hasMore && <Box ref={sentinelRef} minH="1px" />}

      {hasMore && isLoadingMore && (
        <Center py="6">
          <Spinner />
        </Center>
      )}
    </>
  );
};
